import React, { useState } from "react";
import PropTypes from "prop-types";

import { Popper } from "../../../../../../components/simple";
import SVG from "../../../../../../components/SVG";
import { defaultOptions } from "../../../../../../helpers/popoverOptions";

import styles from "./variable.module.scss";

const Variable = ({ variable, onRemoveVariable, showOperator }) => {
  const [isVariablePopover, setVariablePopover] = useState(false);
  return (
    <>
      <div
        id={`var-${variable.id}`}
        className={`${styles["variable-dnd-item"]} ${
          !variable.active ? styles.inactive : ""
        }`}
        onMouseEnter={() => {
          if (!variable.active) setVariablePopover(true);
        }}
        onMouseLeave={() => {
          setVariablePopover(false);
        }}
      >
        {variable.name}
        <button
          type="button"
          className={styles["variable-dnd-item-remove"]}
          onClick={() => onRemoveVariable(variable.id)}
        >
          <SVG.Close width={20} height={20} />
        </button>
        {!variable.active ? (
          <div className={styles["inactive-icon"]}>
            <SVG.InfoCircle width={20} height={20} />
          </div>
        ) : null}
      </div>
      {showOperator ? (
        <div className={styles["variables-operator"]}>or</div>
      ) : null}
      <Popper
        popperOptions={{
          className: `${defaultOptions.className} alert-popper`,
          placement: "bottom",
          target: `var-${variable.id}`,
          isOpen: isVariablePopover,
          toggle: () => {
            setVariablePopover(false);
          }
        }}
      >
        <div className="help-container">
          <h4>Notification</h4>
          <p>
            Some of the selected variables were changed. Please make adjustment
          </p>
        </div>
      </Popper>
    </>
  );
};

Variable.propTypes = {
  variable: PropTypes.shape({
    active: PropTypes.bool,
    name: PropTypes.string,
    id: PropTypes.string
  }).isRequired,
  onRemoveVariable: PropTypes.func,
  showOperator: PropTypes.bool
};

Variable.defaultProps = {
  onRemoveVariable: () => {},
  showOperator: false
};

export default Variable;
